import { LawScope } from '@livv/models';
import { FC } from 'react';
import ContentLogo, { ContentLogoCoreProps } from '.';

interface LawScopeLogoProps extends ContentLogoCoreProps {
    lawScope: LawScope;
}

const LawScopeLogo: FC<LawScopeLogoProps> = ({ lawScope, ...contentLogoProps }) => (
    <ContentLogo contentType="lawScope" contentTypeValue={lawScope} {...contentLogoProps} />
);

export default LawScopeLogo;
